import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  ListItemIcon,
  CircularProgress,
  AppBar,
  Toolbar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccountBoxIcon from "@mui/icons-material/AccountBox"; // Ícono para Datos
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar"; // Ícono para Vehículos
import PersonIcon from "@mui/icons-material/Person"; // Ícono para Choferes
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Collapse, Grow } from "@mui/material";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import { useLocation, useNavigate } from "react-router-dom";
import { UrlApiEnvasado } from "../../../../../services/apirest";
import Navbar from "../../../../Navbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search"; // Ícono de lupa
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { useFechas } from "../../../context/FechaContext";

function ChoferesSucursal() {
  let location = useLocation();
  let navigate = useNavigate();
  const {
    desdeButano,
    hastaButano,
    desdePropano,
    hastaPropano,
    setDesdeButano,
    setHastaButano,
    setDesdePropano,
    setHastaPropano,
  } = useFechas();
  const [choferesButano, setChoferesButano] = useState([]);
  const [choferesPropano, setChoferesPropano] = useState([]);
  const [pageButano, setPageButano] = useState(0);
  const [pagePropano, setPagePropano] = useState(0);
  const rowsPerPage = 10;
  const [tablaElegida, setTablaElegida] = useState();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  // Estado para controlar la tabla expandida (null si ambas están visibles)
  const [expandedTable, setExpandedTable] = useState(null);
  // Estado para el término de búsqueda
  const [searchTermButano, setSearchTermButano] = useState("");
  const [searchTermPropano, setSearchTermPropano] = useState("");

  // Estado para controlar la visibilidad del campo de búsqueda
  const [showSearchButano, setShowSearchButano] = useState(false);
  const [showSearchPropano, setShowSearchPropano] = useState(false);
  // Estado para controlar la carga
  const [loadingButano, setLoadingButano] = useState(false);
  const [loadingPropano, setLoadingPropano] = useState(false);

  const [origen, setOrigen] = useState("");
  useEffect(() => {
    if (location.state.row.origen === "bk1_aws_hipergas") {
      setOrigen("api/estadistica");
    } else if (location.state.row.origen === "bk1_aws_aogas") {
      setOrigen("db2/api/estadisticaaogas");
    }
  }, [location.state]);
  // Fetch para Butano
  const obtenerButano = () => {
    setLoadingButano(true);
    fetch(
      `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xchofer/choferesbutano/${desdeButano} 00:00:00/${hastaButano} 23:59:59/${location.state.row.id_suc}`
    )
      .then((data) => data.json())
      .then((data) => {
        setChoferesButano(data);
        setLoadingButano(false);
      })
      .catch(() => setLoadingButano(false));
  };

  // Fetch para Propano
  const obtenerPropano = () => {
    setLoadingPropano(true);
    fetch(
      `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xchofer/choferespropano/${desdePropano} 00:00:00/${hastaPropano} 23:59:59/${location.state.row.id_suc}`
    )
      .then((data) => data.json())
      .then((data) => {
        setChoferesPropano(data);
        setLoadingPropano(false);
      })
      .catch(() => setLoadingPropano(false));
  };

  // Ejecutar las funciones al montar el componente
  useEffect(() => {
    // if (origen !== "") {
      obtenerButano();
      obtenerPropano();
    // }
  }, []);

  // Manejar la expansión de la tabla con animación
  const handleExpand = (table) => {
    setExpandedTable(expandedTable === table ? null : table);
  };

  // Paginación
  const handleNextPage = (type) => {
    if (
      type === "butano" &&
      (pageButano + 1) * rowsPerPage < choferesButano.length
    ) {
      setPageButano(pageButano + 1);
    }
    if (
      type === "propano" &&
      (pagePropano + 1) * rowsPerPage < choferesPropano.length
    ) {
      setPagePropano(pagePropano + 1);
    }
  };

  const handlePrevPage = (type) => {
    if (type === "butano" && pageButano > 0) {
      setPageButano(pageButano - 1);
    }
    if (type === "propano" && pagePropano > 0) {
      setPagePropano(pagePropano - 1);
    }
  };

  // Menú de acciones
  const handleOpenMenu = (event, row, title) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
    setTablaElegida(title);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleDatos = () => {
    navigate("/panelchofernetizar", {
      state: {
        row: selectedRow,
        origen: location.state.row.origen,
        tabla: tablaElegida,
      },
    });
  };

  const handleFacturacion = () => {
    navigate("/facturacionchofernetizar", {
      state: {
        row: selectedRow,
        origen: location.state.row.origen,
        tabla: tablaElegida,
      },
    });
  };

  const handleRanking = () => {
    if (tablaElegida === "Butano") {
      navigate("/rankingfacturaschofernetizar", {
        state: { row: selectedRow, origen: location.state.row.origen },
      });
    } else {
      navigate("/rankingchoferpropanonetizar", {
        state: { row: selectedRow, origen: location.state.row.origen },
      });
    }
  };

  const filterChoferes = (choferes, searchTerm) => {
    return choferes.filter((chofer) =>
      chofer.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Renderizar tabla con animación y carga
  const renderTable = (
    title,
    page,
    setPage,
    choferes,
    fechaDesde,
    fechaHasta,
    setFechaDesde,
    setFechaHasta,
    loading,
    searchTerm,
    setSearchTerm,
    showSearch,
    setShowSearch
  ) => (
    <Grow in={expandedTable === null || expandedTable === title} timeout={500}>
      <Grid
        item
        xs={expandedTable ? 12 : 6}
        sx={{
          border: "1px solid #97C6E3",
          display: expandedTable && expandedTable !== title ? "none" : "flex",
          flexDirection: "column",
          height: "100%",
          transition: "all 0.5s ease",
        }}
      >
        {/* Encabezado */}
        <Box
          sx={{
            backgroundColor: "#1F618D",
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Centra el título
            position: "relative", // Permite posicionar el botón de forma absoluta
          }}
        >
          <Typography variant="h5" color="#fff">
            {title}
          </Typography>
          <IconButton
            onClick={() => handleExpand(title)}
            sx={{
              color: "#fff",
              position: "absolute", // Lo saca del flujo y lo posiciona
              right: 8, // Lo alinea a la derecha
            }}
          >
            {expandedTable === title ? (
              <CloseFullscreenIcon sx={{ color: "#fff" }} />
            ) : (
              <OpenInFullIcon sx={{ color: "#fff" }} />
            )}
          </IconButton>
        </Box>

        {/* Filtros de fecha, buscador y botón Actualizar */}
        <Box
          sx={{
            display: "flex",
            padding: "7px",
            gap: 1,
            alignItems: "center",
            justifyContent: "space-between", // Distribuye el espacio entre los elementos
          }}
        >
          {/* Elementos alineados a la izquierda */}
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <TextField
              type="date"
              label="Desde"
              value={fechaDesde}
              onChange={(e) => setFechaDesde(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              focused
              sx={{
                width: "130px",
                "& .MuiInputBase-input": {
                  fontSize: "0.875rem", // Achica la fuente del texto dentro del TextField
                },
              }}
            />
            <TextField
              type="date"
              label="Hasta"
              value={fechaHasta}
              onChange={(e) => setFechaHasta(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              focused
              sx={{
                width: "130px",
                "& .MuiInputBase-input": {
                  fontSize: "0.875rem", // Achica la fuente del texto dentro del TextField
                },
              }}
            />
            <Button
              variant="contained"
              onClick={title === "Butano" ? obtenerButano : obtenerPropano}
              disabled={loading}
              size="small"
              sx={{
                padding: "6px 12px",
                fontSize: "0.875rem",
                textTransform: "none",
                backgroundColor: "#3f51b5",
                "&:hover": {
                  backgroundColor: "#303f9f",
                },
              }}
            >
              Actualizar
            </Button>
          </Box>

          {/* Ícono de lupa alineado a la derecha */}
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <IconButton
              onClick={() => setShowSearch(!showSearch)}
              size="small"
              sx={{ color: "#1F618D" }}
            >
              <SearchIcon />
            </IconButton>
            {/* Campo de búsqueda (se muestra solo si showSearch es true) */}
            {showSearch && (
              <TextField
                label="Buscar Chofer"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="small"
                sx={{
                  width: "150px",
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem", // Achica la fuente del texto dentro del TextField
                  },
                }}
              />
            )}
          </Box>
        </Box>

        {/* Tabla o animación de carga */}
        <TableContainer component={Paper} sx={{ flex: 1 }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    Pos.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    Chofer
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    $ Promedio
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    $ Max.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    $ Min.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    Cant. Cli.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    Kg. Vend.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    acc.
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterChoferes(choferes, searchTerm)
                  .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                  .map((chofer, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ padding: "2.5px", borderRight: "1px solid #e0e0e0" }}>
                        {index + 1 + page * rowsPerPage}
                      </TableCell>
                      <TableCell sx={{ padding: "2.5px", borderRight: "1px solid #e0e0e0" }}>
                        {chofer.name}
                      </TableCell>
                      <TableCell sx={{ padding: "1.5px", borderRight: "1px solid #e0e0e0" }} align="right">
                        {Number(chofer.precio_promedio_por_kilo).toFixed(2)}
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "1.5px",
                          fontWeight: "bold", borderRight: "1px solid #e0e0e0"
                        }}
                        align="right"
                      >
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                          {Number(chofer.precio_maximo_por_kilo).toFixed(2)}
                        </Typography>
                      </TableCell>

                      <TableCell
                        sx={{
                          padding: "1.5px",
                          fontWeight: "bold", borderRight: "1px solid #e0e0e0"
                        }}
                        align="right"
                      >
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                          {Number(chofer.precio_minimo_por_kilo).toFixed(2)}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ padding: "1.5px", borderRight: "1px solid #e0e0e0" }} align="right">
                        {chofer.cantidad_clientes_distintos}
                      </TableCell>
                      <TableCell sx={{ padding: "1.5px" , borderRight: "1px solid #e0e0e0"}} align="right">
                        {chofer.kilos_vendidos}
                      </TableCell>
                      <TableCell sx={{ padding: "1.5px" }}>
                        <IconButton
                          onClick={(event) =>
                            handleOpenMenu(event, chofer, title)
                          }
                          size="small"
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>

        {/* Menú de acciones */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={handleDatos}>
            <ListItemIcon>
              <ZoomInIcon fontSize="small" color="primary" />
            </ListItemIcon>
            Datos
          </MenuItem>
          <MenuItem onClick={handleFacturacion}>
            <ListItemIcon>
              <ReceiptLongIcon fontSize="small" color="action" />
            </ListItemIcon>
            Facturación
          </MenuItem>
          <MenuItem onClick={handleRanking}>
            <ListItemIcon>
              <SignalCellularAltIcon fontSize="small" color="success" />
            </ListItemIcon>
            Ranking Facturas
          </MenuItem>
        </Menu>

        {/* Paginación */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "3px",
            alignItems: "center",
          }}
        >
          <IconButton
            onClick={() => handlePrevPage(title.toLowerCase())}
            disabled={page === 0}
            sx={{
              color: page === 0 ? "gray" : "#1F618D",
              backgroundColor: page === 0 ? "lightgray" : "#E3F2FD",
              borderRadius: "50%",
              padding: "3px",
            }}
          >
            <ChevronLeftIcon />
          </IconButton>

          <Typography>Página {page + 1}</Typography>

          <IconButton
            onClick={() => handleNextPage(title.toLowerCase())}
            disabled={(page + 1) * rowsPerPage >= choferes.length}
            sx={{
              color:
                (page + 1) * rowsPerPage >= choferes.length
                  ? "gray"
                  : "#1F618D",
              backgroundColor:
                (page + 1) * rowsPerPage >= choferes.length
                  ? "lightgray"
                  : "#E3F2FD",
              borderRadius: "50%",
              padding: "3px",
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Grid>
    </Grow>
  );

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "#1F618D" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  textAlign: "center",
                  pointerEvents: "none", // Evita que el título intercepte clicks
                }}
              >
            Choferes de {location.state.row.nombre_sucursal}
          </Typography>
          <Typography
                variant="caption"
                sx={{ color: "#EAF2F8", fontStyle: "italic", marginLeft: "auto" }}
              >
                * Todos los precios están expresados sin impuestos
              </Typography>
        </Toolbar>
        
      </AppBar>
      <Box sx={{ height: "90vh" }}>
        <Grid container sx={{ height: "100%" }}>
          {renderTable(
            "Butano",
            pageButano,
            setPageButano,
            choferesButano,
            desdeButano,
            hastaButano,
            setDesdeButano,
            setHastaButano,
            loadingButano,
            searchTermButano,
            setSearchTermButano,
            showSearchButano,
            setShowSearchButano
          )}
          {renderTable(
            "Propano",
            pagePropano,
            setPagePropano,
            choferesPropano,
            desdePropano,
            hastaPropano,
            setDesdePropano,
            setHastaPropano,
            loadingPropano,
            searchTermPropano,
            setSearchTermPropano,
            showSearchPropano,
            setShowSearchPropano
          )}
        </Grid>
      </Box>
    </>
  );
}

export default ChoferesSucursal;
